module.exports = require('./methods/xe-utils')



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/ctor.js
// module id = blCz
// module chunks = 125